module.exports = __webpack_public_path__ + "img/IMG_0859.63711fed.png";